import { isNil } from 'ramda';

import { Option } from '../components/shared/ControlledFields/ControlledSelect';

/**
 * This function for creating value - label array pairs from an array of object.
 */
const mapToOptions = <T extends { [key: string]: any }>(
  arr: T[],
  optionValueGetter: keyof T,
  optionLabelGetter: keyof T
): Array<Option> => {
  if (isNil(arr)) {
    return [];
  }

  return arr
    .map((item) => ({
      value: item[optionValueGetter],
      label: item[optionLabelGetter]
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export default mapToOptions;
